<template>
  <div class="new-features">
    <router-view />
    <div class="content--main">
      <div class="features-wrapper">
        <h4>Here's a Preview of QSpace's Upcoming Features:</h4>
        <ul class="feature-list">
          <li v-for="(feature, i) in features" :key="i">{{ feature }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminNewFeatures",
  data() {
    return {
      features: [
        "Credits System & Loyalty Program",
        "Coworking Passport",
        "Partners Store",
        "Community Feed",
        "Member & Staff Directory",
        "Helpdesk",
        "Mobile App",
        "Automated Billing",
        "Leads Management",
        "Tour Calendar",
        "Proposal & Contracts",
        "Daily Check-ins",
        "Sell Event Tickets",
        "Event Check-ins",
        "Printing Management",
        "Multi-Location Support",
        "White Label Controls",
        "Manage Partner Services",
        "Advanced Reporting",
        "Floor & Seat Plans",
        "Buildout Calculator",
        "QSpace TV Stream",
        "Website CMS",
        "3rd Party Integrations"
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/custom/_variables.scss";

.new-features {
  height: calc(100vh - 183px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 15px;
  .content--main {
    padding-bottom: 20px;
    padding-top: 20px;
    .features-wrapper {
      background-color: $gray-50;
      padding: 45px 30px;
      h4 {
        font-family: "Gotham";
        font-size: $font-size-base;
        font-weight: 500;
        margin-bottom: 49px;
      }
      ul {
        list-style-position: inside;
        padding: 0;
        li {
          color: $gray-900;
          font-family: "Gotham Book";
          font-size: $font-size-xs;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
